import { Box } from "@mui/material";
import React from "react";
import { colors } from "../../constants/site-content";

interface TimerOptionItemProps {
  number?: number;
  timeUnit?: string;
  setTimeLimit: () => void;
  unlimited?: boolean;
}

const TimerOptionItem: React.FC<TimerOptionItemProps> = ({
  number,
  timeUnit,
  setTimeLimit,
}) => {
  return (
    <div>
    <Box
        sx={{
            width: "200px",
            height: "200px",
            border: `1px solid ${colors.brandColor}`,
            backgroundSize: "cover",
            cursor: "pointer",
            color: "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
        }}
        onClick={setTimeLimit}
    >
        {number && timeUnit ? (
          <>
            <Box sx={{ fontSize: "64px" }}>{number}</Box>
            <Box sx={{ fontSize: "24px" }}>{timeUnit}</Box>
          </>
        ) : (
          <Box sx={{ fontSize: "32px" }}>Unlimited</Box>
        )}
      </Box>
    </div>
  );
};

export default TimerOptionItem;
